import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'
import { useActivateContentsquareExperiment } from 'contentsquare'

import { EXPERIMENT_NAME_PERSONAL_ADVICE_DIALOG } from '../../experiments/model/EXPERIMENT_NAME'

import { usePersonalAdviceDialogWithoutAccordionContext } from './PersonalAdviceDialogWithoutAccordionContext'
import { DynamicPersonalAdviceDialogWithoutAccordionContent } from './ProductPersonalAdviceDialogWithoutAccordionContent/DynamicPersonalAdviceDialogWithoutAccordionContent'

export const PersonalAdviceDialogWithoutAccordion: FC = () => {
  useActivateContentsquareExperiment(EXPERIMENT_NAME_PERSONAL_ADVICE_DIALOG)

  const { dialogControls, product, selectedContent } =
    usePersonalAdviceDialogWithoutAccordionContext()

  if (selectedContent) {
    return selectedContent
  }

  return (
    <Dialog onClose={dialogControls.handleClose} open={dialogControls.isOpen}>
      <DialogTitle onClose={dialogControls.handleClose}>
        <FormattedMessage id="buyBox.modal.advice.headline.new" />
      </DialogTitle>
      <DialogContent>
        <DynamicPersonalAdviceDialogWithoutAccordionContent product={product} />
      </DialogContent>
    </Dialog>
  )
}
